import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Role } from 'src/app/enums/role';
import { Agent } from 'src/app/model/agent';
import { Merchant } from 'src/app/model/merchant';
import { Personal } from 'src/app/model/personal';
import { User } from 'src/app/model/user';
import { UserAddress } from 'src/app/model/user.address';
import { CommonService } from 'src/app/services/common.service';
import { StorageService } from 'src/app/services/storage.service';
import { AppConstants } from 'src/app/settings/app-constants';
import { MessageConstant } from 'src/app/settings/message.constant';

@Component({
    selector: 'app-user-agent-profile',
    templateUrl: './user-agent-profile.component.html',
    styleUrls: ['./user-agent-profile.component.css'],
})
export class UserAgentProfileComponent implements OnInit {
    display = false;
    user: User;
    role = Role;
    id: string;
    displaySuccess = false;
    sMessage = '';
    eMessage = '';

    constructor(
        private commonService: CommonService,
        private route: ActivatedRoute,
        private storageService: StorageService,
    ) {
        this.user = new User();
    }

    ngOnInit() {
        this.route.paramMap.subscribe((params) => {
            this.id = params.get('id');
            this.getData();
        });
    }

    initializeUser() {
        if (this.user.userPersonalProfileModel === null) {
            this.user.userPersonalProfileModel = new Personal();
        }
        if (this.user.userBusinessProfileModel === null) {
            this.user.userBusinessProfileModel = new Merchant();
        }
        if (this.user.userAgentProfileModel === null) {
            this.user.userAgentProfileModel = new Agent();
            if (this.user.userAgentProfileModel.address === null) {
                this.user.userAgentProfileModel.address = new UserAddress();
            }
        }
        this.user.profilePicture = this.user.userPersonalProfileModel.profilePicture;
        this.user.lastLogin = this.user.userAgentProfileModel.lastLogin;
    }

    getData() {
        if (
            !!this.storageService.getProfileUser() &&
            this.storageService.getProfileUser().id == this.id
        ) {
            this.user = this.storageService.getProfileUser();
            this.initializeUser();
        } else {
            this.getProfile();
        }
    }

    getProfile() {
        this.commonService.getUserProfile(this.id).subscribe(
            (res) => {
                this.user = res.data;
                this.initializeUser();
                this.storageService.setProfileUser(this.user);
            },
            (err) => {
            },
        );
    }

    updateReferralCode(code: string) {
        if (code.length < AppConstants.REFERRAL_CODE_MIN_LEGTH) {
            this.eMessage = 'Invalid referral code.';
            this.display = true;
        } else {
            this.commonService.updateReferralCode(this.user.id, code).subscribe(
                (res) => {
                    if (res.success) {
                        this.getProfile();
                    } else {
                        this.eMessage = res.status.message;
                        this.display = true;
                    }
                },
                (error) => {
                    this.eMessage = MessageConstant.REFERRAL_CODE_UPDATE_REQUEST_FAILED;
                    this.display = true;
                },
            );
        }
    }
}
